// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 597 ? "admin-panel" : chunkId) + "." + {"570":"41162e54","597":"effc6e4e"}[chunkId] + ".chunk.js";
};